import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { getResponseMessage } from '../../../../utils/utils';
import { getCategoryParents } from '../../../../crud/categories.crud';
import { ICategoryItem } from '../../categories/interfaces';

export const useGetParentsCategories = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState<ICategoryItem | null>(null);

  const fetch = async (id: number) => {
    setLoading(true);
    getCategoryParents(id)
      .then((res: any) => {
        setCategory(res.data.data);
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { fetch, loading, category };
};
